const nlPostcode = (value) => {
  const pattern = /^\d{4} [A-Z]{2}$/;
  
  if (!(pattern.test(value))) {
    return ['checkout.error.formFields.postalCode', '0000 XX'];
  }
};

export default nlPostcode;
